import React, { useState } from 'react';
import axios from 'axios';
import { requireLogin } from '@/components/helpers/authHelpers';

interface FavoriteProps {
  signedIn: boolean;
  favoritableType: string;
  favoritableId: number;
  favorited: boolean;
}

export function Favorite({ signedIn, favoritableType, favoritableId, favorited }: FavoriteProps) {
  const [isFavorited, setIsFavorited] = useState(favorited);

  const toggleFavorite = async () => {
    const params = { favoritable_type: favoritableType, favoritable_id: favoritableId };
    isFavorited ? await axios.delete('/api/favorites', { params }) : await axios.post('/api/favorites', params);
    setIsFavorited((oldState) => !oldState);
  };

  const click = () => {
    if (!signedIn) return requireLogin();
    toggleFavorite();
  };

  const label = isFavorited ? 'Remove from favorites' : 'Save to favorites';
  return (
    <button type="button" onClick={click} aria-label={label} aria-pressed={isFavorited} className="favorite-button">
      <i aria-hidden="true" className={isFavorited ? 'favorite fa fa-heart' : 'favorite fa fa-heart-o'} />
    </button>
  );
}
